export default [
  {
    'id': 0,
    'name': '',
    'item':[
      {
        'id': 1000,
        'name': '案内所'
      },
      {
        'id': 1011,
        'name': '料金所'
      }
    ]
  },
  {
    'id': 1,
    'name': '',
    'item':[
      {
        'id': 1001,
        'name': '化粧室'
      },
      {
        'id': 1003,
        'name': '多目的トイレ'
      },
      {
        'id': 1008,
        'name': 'オストメイト'
      }
    ]
  },
  {
    'id': 2,
    'name': '',
    'item':[
      {
        'id': 1002,
        'name': 'ベビーチェア・ベビーベッド'
      },
      {
        'id': 1006,
        'name': 'ベビーカート・車いす貸出'
      },
      {
        'id': 1010,
        'name': '授乳室'
      }
    ]
  },
  {
    'id': 3,
    'name': '',
    'item': [
      {
        'id': 1004,
        'name': '飲食・売店'
      },
      {
        'id': 1007,
        'name': '休憩所'
      },
      {
        'id': 1012,
        'name': '喫煙所'
      }
    ]
  },
  {
    'id': 4,
    'name': '',
    'item': [
      {
        'id': 1005,
        'name': 'コインロッカー'
      },
      {
        'id': 1009,
        'name': '救護室'
      },
      {
        'id': 1014,
        'name': '展示室'
      }
    ]
  }
];


// WEBPACK FOOTER //
// ./map/js/ih/extend/FacilityCategory.js